<h1 class="ml-5 mt-4" style="color: #0f2765">Iniciar sesión</h1>
<div class="card flex justify-center m-5">
  <p-stepper [(value)]="activeStep" class="w-full" [linear]="true">
    <p-step-list>
      <p-step [value]="1">Fecha nacimiento</p-step>
      <p-step [value]="2">Preguntas</p-step>
    </p-step-list>
    <p-step-panels>
      <p-step-panel [value]="1">
        <ng-template #content>
          <div class="flex flex-column h-48">
            <p class="my-2">Necesitamos verificar que <strong>seas tú</strong>, por favor ayúdanos completando la siguiente información:</p>
            <div class="flex flex-column gap-2 w-full">
              <label for="fechaNacimiento" class="font-medium">Fecha de nacimiento (dd/mm/aaaa)</label>
              <p-datepicker
                id="fechaNacimiento"
                [(ngModel)]="authStore.loginData().fechaNacimiento"
                name="fechaNacimiento"
                [showIcon]="true"
                placeholder="dd/mm/aaaa"
                appendTo="body"
              />
            </div>
            <div class="flex pt-4 justify-content-end gap-2">
              <button
                miButton="back"
                [miButtonIcon]="'solar:round-alt-arrow-left-broken'"
                (click)="prevStep(1)"
              >
                Atrás
              </button>
              <button
                miButton="primary"
                [miButtonIcon]="'solar:round-alt-arrow-right-bold-duotone'"
                [disabled]="!authStore.loginData().fechaNacimiento"
                (click)="nextStep(2)"
              >
                Siguiente
              </button>
            </div>
          </div>
        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="2">
        <ng-template #content>
          <div class="flex flex-column h-48">
            <div class="text-center mt-0 mb-5 text-xl font-semibold">
              {{ preguntas[activePregunta].pregunta }}
            </div>
            <div class="flex flex-column gap-2">
              @for (opcion of preguntas[activePregunta].items; track $index) {
                <div class="flex gap-2 w-full">
                  <!-- Modifica el radio button para establecer la opción en el objeto respuesta -->
                  <p-radioButton
                    class="w-2rem"
                    name="opcionReto"
                    [value]="opcion"
                    [(ngModel)]="respuestas[activePregunta].opcion"
                  />
                  <span class="w-full">{{ opcion }}</span>
                </div>
              }
            </div>
          </div>
          <div class="flex pt-3 justify-content-end gap-2">
            <button miButton="back" [miButtonIcon]="'solar:round-alt-arrow-left-broken'" (click)="activePregunta === 0 ? prevStep(1) : prevPregunta()">
              Atrás
            </button>
            @if (activePregunta < preguntas.length - 1) {
              <button
                miButton="primary"
                [miButtonIcon]="'solar:round-alt-arrow-right-bold-duotone'"
                (click)="nextPregunta()"
                [disabled]="!respuestas[activePregunta].opcion"
              >
                Siguiente
              </button>
            }
            @if (activePregunta === preguntas.length - 1) {
              <button
                miButton="primary"
                [miButtonIcon]="'solar:login-2-bold-duotone'"
                (click)="validateAnswers()"
                [disabled]="!respuestas[activePregunta].opcion"
              >
                Ingresar
              </button>
            }
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
</div>
